export var propsToNotForward = ['active', 'design'];
